import type { lib } from "../client";

/** TypeIDs serialize to plain strings at runtime. */
export const artworkId = (id: lib.ArtworkId): string => id as unknown as string;
export const imageId = (id: lib.ImageId): string => id as unknown as string;
export const inquiryId = (id: lib.InquiryId): string => id as unknown as string;
